import { GetterTree } from 'vuex'
import { YearModule } from '..'
import { BBTreeviewNode } from '../../types'
import { toFilterSets } from '../../utils/filters/filters.generics'

export const getters: GetterTree<typeof YearModule['state'], unknown> = {
  yearsAsTreeNodes(state): BBTreeviewNode {
    return {
      name: 'Year',
      id: 'all_years',
      groupingKey: 'year',
      type: 'Checkbox',
      children: [
        ...toFilterSets(state.all, year => {
          return {
            id: year._id,
            value: year._id,
            name: year.name,
            groupingKey: 'year',
            type: 'Checkbox'
          }
        }),
        {
          id: 'year_not_set',
          value: null,
          name: 'Not Set',
          groupingKey: 'year',
          type: 'Checkbox'
        }
      ]
    }
  }
}
